@if (isDesktop) {
<ng-container *ngTemplateOutlet="monitoring"></ng-container>
} @else {
<ion-content [fullscreen]="true" class="soft-background">
  <ng-container *ngTemplateOutlet="monitoring"></ng-container>
</ion-content>
}

<ng-template #monitoring>

  <div class="page-wrapper" [class.page-wrapper_multi]="isDesktop && currentSegment === 'multi'"
    [class.mentorage-tutorial-active]="mentorageTutorialActive"
    [class.mentorage-tutorial-desktop]="mentorageTutorialActive && isDesktop"
    [class.mentorage-step-overview]="mentorageTutorialActive && mentorageTutorialStepIndex === 0"
    [class.mentorage-step-room]="mentorageTutorialActive && mentorageTutorialStepIndex === 2"
    [class.mentorage-step-alerts]="mentorageTutorialActive && mentorageTutorialStepIndex === 3">

    <div class="monitoring-header-clean">
      <ion-segment #tutorialSegmentElement [value]="currentSegment" (ionChange)="onSegmentChange($event.detail.value)" mode="ios"
        class="clean-segment" [class.clean-segment_desktop]="isDesktop"
        [class.mentorage-tutorial-target]="mentorageTutorialActive && mentorageTutorialStepIndex === 0">
        <ion-segment-button #tutorialStructureElement value="structure"
          [class.mentorage-tutorial-target]="mentorageTutorialActive && mentorageTutorialStepIndex === 1">
          <ion-label>Struttura</ion-label>
        </ion-segment-button>
        <ion-segment-button #tutorialAlertsElement value="allerts"
          [class.mentorage-tutorial-target]="mentorageTutorialActive && mentorageTutorialStepIndex === 3">
          <div class="segment-label-wrapper">
            <ion-label>Allerte</ion-label>
            @if (showTutorialAlertList && !tutorialAlertManaged) {
            <span class="segment-badge-clean">1</span>
            } @else if (!showTutorialAlertList && alertsList.length) {
            <span class="segment-badge-clean">{{alertsList.length}}</span>
            }
          </div>
        </ion-segment-button>
        @if (isDesktop) {
        <ion-segment-button #tutorialMultiElement value="multi"
          [class.mentorage-tutorial-target]="mentorageTutorialActive && mentorageTutorialStepIndex === 5">
          <ion-label>Vista multipla</ion-label>
        </ion-segment-button>
        }
      </ion-segment>
    </div>

    <div class="segment-view-container">

      @if (currentSegment === 'structure') {
      <div class="segment-panel">
        @if (sharedSrv.canViewBedStates) {
          <app-bed-states-session></app-bed-states-session>
        }
        @if (isDesktop && isSpatialTrackingEnabled && spatialAvailabilityError && !isDataLoading) {
          <div class="spatial-availability-error" role="alert">
            <span>{{spatialAvailabilityError}}</span>
            <button type="button" (click)="refreshSpatialAvailability()">Aggiorna stato Spatial</button>
          </div>
        }
        @if (canSwitchSpatialView && !isDataLoading) {
          <div class="spatial-view-controls">
            <div class="spatial-view-switch" role="group" aria-label="Visualizzazione struttura">
              <button type="button" [class.active]="structureView === 'cards'" [attr.aria-pressed]="structureView === 'cards'" (click)="setStructureView('cards')">Card</button>
              <button type="button" [class.active]="structureView === 'map'" [attr.aria-pressed]="structureView === 'map'" (click)="setStructureView('map')">Mappa</button>
            </div>
            @if (showSpatialMap && mapUnits.length > 1) {
              <div class="spatial-unit-navigation" role="group" aria-label="Navigazione unità con mappa">
                <button type="button" aria-label="Unità precedente con mappa" [disabled]="selectedSpatialUnitIndex <= 0" (click)="moveSpatialUnit(-1)">‹</button>
                <button type="button" aria-label="Unità successiva con mappa" [disabled]="selectedSpatialUnitIndex >= mapUnits.length - 1" (click)="moveSpatialUnit(1)">›</button>
              </div>
            }
          </div>
        }

        @if (isDataLoading) {
        <div class="loading-wrapper">
          <mat-spinner diameter="50"></mat-spinner>
        </div>
        } @else if (!showSpatialMap && unitsTree.length) {

        <div class="units-container">
          <mat-expansion-panel *ngFor="let unit of unitsTree"
            [expanded]="unitsTree.length === 1"
            (opened)="unit.isOpen = true" (closed)="unit.isOpen = false" class="pop-out-card" hideToggle>

            <mat-expansion-panel-header>
              <mat-panel-title>
                <span class="unit-title">{{unit.name}}</span>
                <div class="unit-indicators">
                  <div *ngFor="let icon of getUnitAlerts(unit)" class="indicator-dot"
                    [style.background-color]="icon.color" [class.blinking]="!unit.isOpen">
                    <mat-icon>{{icon.icon}}</mat-icon>
                  </div>
                  <mat-icon class="chevron-icon">{{unit.isOpen ? 'expand_less' : 'expand_more'}}</mat-icon>
                </div>
              </mat-panel-title>
            </mat-expansion-panel-header>

            <div class="rooms-grid-wrapper">
              <mat-grid-list cols="8" [rowHeight]="sharedSrv.canViewBedStates ? '192px' : '126px'" gutterSize="12px">
                <ng-container *ngFor="let room of unit.rooms; let i = index">
                  <mat-grid-tile [colspan]="isDesktop ? 2 : 4" [rowspan]="1"
                    (click)="openModal(room)">

                    <div class="room-card" [class.is-alert]="room.alert"
                      [class.has-bed-states]="sharedSrv.canViewBedStates"
                      [class.is-offline]="room.offlineMode === 'full'"
                      [style.border-color]="room.alert ? eventTypeToData[room.alert.eventType].exaColor : ''">

                      <div class="card-header">
                        <span class="room-name" [class.text-offline]="room.offlineMode === 'full'">
                          {{room.name}}
                        </span>

                        <div class="indicators-wrapper">

                          @if (room.bedExitDelayMinutes) {
                          <div class="indicator-item delay-indicator">
                            <mat-icon svgIcon="bed_exit_delay_clock"></mat-icon>
                            <span class="indicator-value">{{room.bedExitDelayMinutes}}</span>
                          </div>
                          }

                          @if (room.notificationSilencedList?.status !== 'active' &&
                          room.notificationSilencedList?.status) {
                          <div class="indicator-item silenced-indicator"
                            [class.partially-silenced-indicator]="room.notificationSilencedList?.status === 'partial'"
                            [attr.title]="room.notificationSilencedList?.status === 'partial'
                              ? 'Alcune notifiche sono disattivate'
                              : 'Tutte le notifiche sono disattivate'">
                            <mat-icon>notifications</mat-icon>
                          </div>
                          }
                        </div>
                      </div>

                      <div class="card-body">

                        @if (sharedSrv.canViewBedStates) {
                          <app-bed-states-room [roomId]="room.id || ''" [unitId]="unit.id || ''"></app-bed-states-room>
                        }
                        @else if (room.alert) {
                        <div class="icon-container alert-mode">
                          <mat-icon [svgIcon]="eventTypeToData[room.alert.eventType].svgIcon"
                            class="main-icon alert-icon" [style.color]="eventTypeToData[room.alert.eventType].exaColor">
                          </mat-icon>
                        </div>
                        }
                        @else if (room.offlineMode) {
                        <div class="icon-container offline-mode">
                          <mat-icon [svgIcon]="eventTypeToData['06'].svgIcon" class="main-icon offline-icon"></mat-icon>
                        </div>
                        }
                        @else {
                        <div class="icon-container normal-mode">
                          <mat-icon svgIcon="bed" class="main-icon bed-icon"></mat-icon>

                          @if(room.beds?.length) {
                          <span class="bed-count-pill">{{room.beds?.length}}</span>
                          }
                        </div>
                        }
                      </div>

                      <div class="card-footer">
                        @if (room.alert) {
                        <div class="info-chip alert-chip"
                          [style.background-color]="eventTypeToData[room.alert.eventType].exaColor + '15'"
                          [style.color]="eventTypeToData[room.alert.eventType].exaColor">
                          <span class="chip-label">{{room.alert.eventType === '08' ? room.alert.title : (eventTypeToData[room.alert.eventType].translation | translate)}}</span>
                          <span class="chip-dot">•</span>
                          <span class="chip-time">{{getTimeLeft(room.alert.timestamp)}}m</span>
                        </div>
                        } @else if (room.offlineMode === 'full') {
                        <div class="info-chip offline-chip">
                          OFFLINE
                        </div>
                        }
                      </div>

                    </div>
                  </mat-grid-tile>
                </ng-container>
              </mat-grid-list>
            </div>

          </mat-expansion-panel>
        </div>
        } @else if (!showSpatialMap && !(mentorageTutorialActive && mentorageTutorialStepIndex === 2)) {
        <ng-container *ngTemplateOutlet="noSensors"></ng-container>
        }

        @if (mentorageTutorialActive && mentorageTutorialStepIndex === 2 && !isDataLoading) {
        <div class="tutorial-example-room-wrapper">
          <button #tutorialExampleRoomElement type="button"
            class="room-card tutorial-example-room-card mentorage-tutorial-room-target"
            (click)="openTutorialExampleRoom()">
            <span class="card-header">
              <span class="room-name">{{'MENTORAGE_TUTORIAL.DEMO.ROOM' | translate}}</span>
              <span class="tutorial-example-badge">{{'MENTORAGE_TUTORIAL.DEMO.BADGE' | translate}}</span>
            </span>
            <span class="card-body">
              <span class="icon-container normal-mode">
                <mat-icon svgIcon="bed" class="main-icon bed-icon"></mat-icon>
              </span>
            </span>
          </button>
        </div>
        }

        @if (showSpatialMap && !isDataLoading && spatialScope; as scope) {
        <section class="spatial-tracking-section">
          <app-spatial-tracking
            [scope]="scope"
            [units]="spatialUnits"
            [showBedStates]="sharedSrv.canViewBedStates"
            (configurationChanged)="refreshSpatialAvailability()"
            (accessLost)="disableSpatialView($event)"
            (roomSelected)="openModal($event)"></app-spatial-tracking>
        </section>
        }
      </div>

      } @else if (currentSegment === 'allerts') {
      <div class="segment-panel">
        @if (showTutorialAlertList) {
        <div class="alerts-container tutorial-alert-list">
          <p class="tutorial-alert-disclaimer">{{'GUIDE.ALERT_DEMO.DISCLAIMER' | translate}}</p>
          <button #tutorialFallAlertElement type="button" class="alert-card tutorial-fall-alert"
            [class.mentorage-tutorial-room-interactive]="mentorageTutorialStepIndex === 6"
            [class.tutorial-alert-managed]="tutorialAlertManaged"
            [disabled]="mentorageTutorialStepIndex !== 6 || tutorialAlertOpening"
            [style.--alert-color]="tutorialAlertManaged ? '#2f9e72' : eventTypeToData['01'].exaColor"
            (click)="openTutorialAlert()">
            <div class="alert-icon-side">
              @if (tutorialAlertManaged) {
              <mat-icon class="alert-type-icon">check_circle</mat-icon>
              } @else {
              <mat-icon svgIcon="fall" class="alert-type-icon"></mat-icon>
              }
            </div>
            <div class="alert-content">
              <div class="alert-header"><span class="room-title">{{'MENTORAGE_TUTORIAL.DEMO.ROOM' | translate}}</span></div>
              <div class="alert-meta">
                <span class="alert-desc">{{'GENERAL.EVENTS_LIST.FALL' | translate}}</span>
                <span class="alert-time">{{(tutorialAlertManaged ? 'GUIDE.ALERT_DEMO.MANAGED' : 'GUIDE.ALERT_DEMO.BADGE') | translate}}</span>
              </div>
            </div>
            <mat-icon class="tutorial-alert-arrow" aria-hidden="true">chevron_right</mat-icon>
          </button>
        </div>
        } @else if (alertsList.length) {
        <div class="alerts-container">
          <div #tutorialAlertCardElement *ngFor="let alert of alertsList; let first = first" class="alert-card"
            [class.mentorage-tutorial-alert-target]="mentorageTutorialActive && mentorageTutorialStepIndex === 3 && first"
            [style.--alert-color]="eventTypeToData[alert.eventType].exaColor" (click)="openModalFromAlert(alert)">

            <div class="alert-icon-side">
              <mat-icon [svgIcon]="eventTypeToData[alert.eventType].svgIcon" class="alert-type-icon"></mat-icon>
            </div>

            <div class="alert-content">
              <div class="alert-header">
                <span class="room-title">{{alert.facilities.room.name}}</span>
              </div>
              <div class="alert-meta">
                <span class="alert-desc">{{alert.eventType === '08' ? alert.title : (eventTypeToData[alert.eventType].translation | translate)}}</span>
                @if (alert.eventType === '08') {
                <span class="alert-desc">{{alert.body}}</span>
                }
                <span class="alert-time">{{getTimeLeft(alert.timestamp)}} min fa</span>
              </div>
            </div>
          </div>

          <div class="manage-all-wrapper">
            <ion-button expand="block" (click)="manageAll()" [disabled]="manageAllRunning">
              {{manageAllRunning ? '...' : 'Gestisci tutte'}}
            </ion-button>
          </div>
          <div style="height: 100px;"></div>
        </div>
        } @else {
        <section class="monitoring-empty-state" role="status" aria-live="polite">
          <div class="monitoring-empty-icon" aria-hidden="true">
            <mat-icon>notifications_none</mat-icon>
          </div>
          <h3>{{'MONITORING_EMPTY.ALERTS_TITLE' | translate}}</h3>
          <p>{{'MONITORING_EMPTY.ALERTS_DESCRIPTION' | translate}}</p>
        </section>
        }
      </div>

      } @else if (isDesktop && currentSegment === 'multi') {
      <div class="segment-panel segment-panel_multi">
        @if (isDataLoading) {
        <div class="loading-wrapper">
          <mat-spinner diameter="50"></mat-spinner>
        </div>
        } @else if (availableStreamingDevices.length) {
        <div class="multi-view-container">

          <div class="multi-view-layout">
            <aside class="multi-view-sidebar">

              <section class="multi-panel camera-panel">
                <div class="panel-title-row">
                  <h4>Sensori</h4>
                  <span>{{selectedDeviceLabels.length}}/{{maxMultiViewDevices}}</span>
                </div>

                <div class="camera-list">
                  <button type="button" class="camera-option"
                    *ngFor="let device of availableStreamingDevices; trackBy: trackDeviceByLabel"
                    [class.is-selected]="isMultiViewDeviceSelected(device)"
                    [class.is-unavailable]="!isMultiViewDeviceSelectable(device)"
                    [disabled]="isMultiViewDeviceDisabled(device)" (click)="toggleMultiViewDevice(device)">
                    <span class="selection-box" [class.is-selected]="isMultiViewDeviceSelected(device)">
                      @if (isMultiViewDeviceSelected(device)) {
                      <mat-icon>check</mat-icon>
                      }
                    </span>
                    <span class="camera-status-dot" [class.is-online]="device.status === 'online'"></span>
                    <span class="camera-copy">
                      <strong>{{getDeviceRoomLabel(device)}}</strong>
                      <small>{{device.label}}</small>
                    </span>
                    <span class="camera-status" [class.is-online]="isMultiViewDeviceSelectable(device)">
                      {{getDeviceStatusLabel(device)}}
                    </span>
                  </button>
                </div>
              </section>

            </aside>

            <section class="multi-streams-shell">
              @if (selectedStreamingDevices.length) {
              <div class="streams-grid" [class.grid-one]="selectedStreamingDevices.length === 1"
                [class.grid-three]="selectedStreamingDevices.length === 3">
                <div class="stream-tile" *ngFor="let device of selectedStreamingDevices; trackBy: trackDeviceByLabel">
                  <streaming [devices]="$any([device])"></streaming>
                </div>
              </div>
              } @else {
              <div class="multi-empty-state">
                <mat-icon>grid_view</mat-icon>
                <h3>Nessun sensore selezionato</h3>
              </div>
              }
            </section>
          </div>
        </div>
        } @else {
        <ng-container *ngTemplateOutlet="noSensors"></ng-container>
        }
      </div>
      }

    </div>
  </div>

  @if (mentorageTutorialActive && !tutorialAlertOverlayOpen) {
  @if (mentorageTutorialSpotlight; as spotlight) {
  <div class="mentorage-tutorial-spotlight" aria-hidden="true"
    [style.top.px]="spotlight.top"
    [style.left.px]="spotlight.left"
    [style.width.px]="spotlight.width"
    [style.height.px]="spotlight.height"
    [style.border-radius.px]="spotlight.borderRadius">
  </div>
  }

  <section #mentorageTutorialCardElement appTutorialScrollLock class="mentorage-tutorial-card"
    [class.mentorage-tutorial-card-desktop]="isDesktop"
    [class.mentorage-tutorial-card-positioned]="!!mentorageTutorialCardPosition"
    [style.top.px]="isDesktop ? mentorageTutorialCardPosition?.top : null"
    [style.left.px]="isDesktop ? mentorageTutorialCardPosition?.left : null"
    role="dialog" aria-modal="true" aria-live="polite" tabindex="-1">
    <button type="button" class="mentorage-tutorial-skip" (click)="skipMentorageTutorial()">
      {{'MENTORAGE_TUTORIAL.BUTTONS.SKIP' | translate}}
    </button>

    <span class="mentorage-tutorial-progress">
      {{'MENTORAGE_TUTORIAL.PROGRESS' | translate: {
      current: mentorageTutorialProgressIndex + 1 + mentorageGuideNavigationOffset,
      total: mentorageTutorialSteps.length + mentorageGuideNavigationOffset
      } }}
    </span>
    <h2>{{getMentorageTutorialTranslationKey('TITLE') | translate}}</h2>
    <p>{{getMentorageTutorialTranslationKey('DESCRIPTION') | translate}}</p>

    @if (mentorageTutorialStepIndex === 3 && !alertsList.length) {
    <div class="mentorage-demo-box">
      <span class="mentorage-demo-label">{{'MENTORAGE_TUTORIAL.DEMO.LABEL' | translate}}</span>
      <div class="mentorage-demo-alert">
        <mat-icon svgIcon="bed_out"></mat-icon>
        <span><strong>{{'MENTORAGE_TUTORIAL.DEMO.ROOM' | translate}}</strong>
          <small>{{'GENERAL.EVENTS_LIST.BED_OUT' | translate}} · 1 min</small></span>
      </div>
    </div>
    }

    @if (mentorageTutorialStepIndex === 4) {
    <div class="mentorage-alert-legend">
      @for (eventType of tutorialAlertTypes; track eventType) {
      <div class="mentorage-alert-type" [style.--tutorial-alert-color]="eventTypeToData[eventType].exaColor">
        <mat-icon [svgIcon]="eventTypeToData[eventType].svgIcon"></mat-icon>
        <span>{{eventTypeToData[eventType].translation | translate}}</span>
      </div>
      }
    </div>
    }

    <div class="mentorage-tutorial-actions">
      <button type="button" class="mentorage-tutorial-secondary" (click)="previousMentorageTutorialStep()"
        [disabled]="mentorageTutorialProgressIndex === 0 && !mentorageGuideNavigationOffset">
        {{'MENTORAGE_TUTORIAL.BUTTONS.BACK' | translate}}
      </button>
      @if (mentorageTutorialStepIndex !== 6) {
      <button type="button" class="mentorage-tutorial-primary" (click)="nextMentorageTutorialStep()">
        {{(mentorageTutorialProgressIndex === mentorageTutorialSteps.length - 1
        ? 'MENTORAGE_TUTORIAL.BUTTONS.FINISH'
        : 'MENTORAGE_TUTORIAL.BUTTONS.NEXT') | translate}}
      </button>
      }
    </div>
  </section>
  }
</ng-template>

<ng-template #noSensors>
  <section class="monitoring-empty-state" role="status" aria-live="polite">
    <div class="monitoring-empty-icon" aria-hidden="true">
      <mat-icon>sensors_off</mat-icon>
    </div>
    <h3>{{'MONITORING_EMPTY.TITLE' | translate}}</h3>
    <p>{{'MONITORING_EMPTY.DESCRIPTION' | translate}}</p>
  </section>
</ng-template>

<ng-template #tutorialExampleDialog>
  <div class="tutorial-example-dialog">
    <div class="tutorial-example-dialog-header">
      <h2>{{'MENTORAGE_TUTORIAL.DEMO.ROOM' | translate}}</h2>
      <button type="button" class="tutorial-example-close-button" [mat-dialog-close]="true"
        [attr.aria-label]="'MENTORAGE_TUTORIAL.DEMO.CLOSE' | translate">
        <mat-icon>close</mat-icon>
      </button>
    </div>
    <mat-dialog-content>
      <div class="tutorial-example-stream">
        <mat-icon>videocam</mat-icon>
        <strong>{{'MENTORAGE_TUTORIAL.DEMO.STREAM' | translate}}</strong>
        <span>{{'MENTORAGE_TUTORIAL.DEMO.DISCLAIMER' | translate}}</span>
      </div>
      <p class="tutorial-example-close-hint">
        <mat-icon>info_outline</mat-icon>
        {{'MENTORAGE_TUTORIAL.ROOM_CLOSE_HINT' | translate}}
      </p>
    </mat-dialog-content>
  </div>
</ng-template>
